import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { CourseType } from '../../types'

type InitialState = {
  courses: CourseType[]
  loading: boolean
}

const initialState: InitialState = {
  courses: [],
  loading: true
}

export const coursesSlice = createSlice({
  name: 'courses',
  initialState,
  reducers: {
    setCourses: (state, action: PayloadAction<InitialState['courses']>) => {
      state.courses = action.payload
    },
    addCourse: (state, action: PayloadAction<InitialState['courses']>) => {
      state.courses = [...state.courses, ...action.payload]
    },
    setCoursesLoading: (state, action: PayloadAction<InitialState['loading']>) => {
      state.loading = action.payload
    }
  }
})

export const { setCourses, setCoursesLoading } = coursesSlice.actions
export default coursesSlice.reducer
